
import {encounterService} from "../../services/medicationmanagement/EncounterApi";
import { ExternalLookupIdentifier } from "@communicare/medications/Shared/SharedModels";
import { communicareServiceApi } from "../../services/communicare/ServiceApi";
import { logger } from "../common/logger";

export type EncounterDetail = ExternalLookupIdentifier;
export const createEncounter = async (authoringSystem:string,authoringSystemForeignKey:string)=>{
    let encounterInfo = await encounterService.createEncounter({
        encounter:{
            authoringSystem,
            authoringSystemForeignKey
        }
    });
  
    //If encounterInfo include patient and facility details (This means New encounter created), 
    //call to communicare get provider  API  to make sure the encounter generated before loading the component 
    if (encounterInfo.patient != null && encounterInfo.encounterPlace != null){
         let currentProvider  = await communicareServiceApi.getCurrentProvider(encounterInfo.encounter.authoringSystem,  encounterInfo.encounter.authoringSystemForeignKey);
         logger.log(currentProvider)
    }

    return{   
        authoringSystem:encounterInfo.encounter.authoringSystem,
        authoringSystemForeignKey:encounterInfo.encounter.authoringSystemForeignKey
    };
}